import {
  subscribeEvent,
  triggerEvent,
  unsubscribeEvent,
} from '@shared/event/event'
import type { ApplyListFiltersEvent } from '@shared/event/events/types'
import type { EventCallback, EventToken } from '@shared/event/types'

const APPLY_LIST_FILTERS_EVENT = 'apply_list_filters'

export const triggerApplyListFiltersEvent = (event: ApplyListFiltersEvent) =>
  triggerEvent(APPLY_LIST_FILTERS_EVENT, event)

export const onApplyListFiltersEvent = (
  callback: EventCallback<ApplyListFiltersEvent>
) => subscribeEvent(APPLY_LIST_FILTERS_EVENT, callback)

export const removeApplyListFiltersEvent = (
  token: EventToken<ApplyListFiltersEvent>
) => unsubscribeEvent(APPLY_LIST_FILTERS_EVENT, token)
